import {ActivatedRoute } from '@angular/router';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DateAdapter, MatDateFormats, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatCalendar, MatDatepicker } from '@angular/material/datepicker';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';


export const MATERIAL_DATEPICKER_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-custom-date-picker',
  templateUrl: './custom-date-picker.component.html',
  styleUrls: ['./custom-date-picker.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MATERIAL_DATEPICKER_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomDatePickerComponent implements OnInit, OnChanges {
  exampleHeader = ExampleHeader;
  @Output() passDates = new EventEmitter();
  @Input() defaultDate;
  @Input() minDate;
  @Input() selectedDate;
  @Input() isDateSelected;
  @Input() hasPlaceHolder = false
  // @Input() max: D | null

  @Input() isFromEstimationCurrent = false;
  @Input() isFromEstimationUpcoming = false;
  @Input() isFromEstimationDropdown = false;
  @Output() isDatePickerOpen = new EventEmitter();
  @Input() hideFutureDates = false
  displayDate: any;
  @Input() hasDateFilter = false
  @Input() hasEndSupportDate = null
  @Input() maxStartDate = null
  @Input() hpDropdownMaxDate = false;
  dateFilter = (date: Date) => ((new Date(date).getFullYear() - 1) > new Date().getFullYear());
  maxDate: any;
  selectedFirstDay = '';
  @ViewChild('hasNoDateFilterRef') hasNoDateFilterRef: MatDatepicker<CustomDatePickerComponent>;
  @ViewChild('hasDateFilterRef') hasDateFilterRef: MatDatepicker<CustomDatePickerComponent>;
  @Input() customPlaceHolder = null
  private _openDatePickerOnKeyStroke = { status: false };
  public get openDatePickerOnKeyStroke() {
    return this._openDatePickerOnKeyStroke;
  }
  @Input()
  public set openDatePickerOnKeyStroke(value) {
    this._openDatePickerOnKeyStroke = value;
    if(this.hasDateFilter && !!this.hasDateFilterRef){
      this.hasDateFilterRef.open();
    }
    if(!this.hasDateFilter && !!this.hasNoDateFilterRef){
      this.hasNoDateFilterRef.open();
    }
  }

  myFilter = (d: any): boolean => {
    let fechaFormat = new Date(d);
    let firstDay = moment(fechaFormat).format('DD')
    if(firstDay == '01') {
      this.selectedFirstDay = moment(fechaFormat).format('DD/MM/YYYY')
    }

    this.startDate = moment(this.minDate, 'DD/MM/YYYY').subtract(2,'days').format();
    let formatFirstDay =  moment(this.selectedFirstDay, 'DD/MM/YYYY').format();


    let startDay = moment(this.startDate).format('DD')
    let startMonth = 1 + moment(this.selectedFirstDay, 'DD/MM/YYYY').month();
    let startYear = moment(this.selectedFirstDay).format('YYYY')

    let newDate = `${startDay}/${startMonth}/${startYear}`
    let isValid = moment(newDate, 'DD/MM/YYYY').isValid()
    let newStartDate: any = moment(newDate, 'DD/MM/YYYY').format();

    let endDate: any = moment(formatFirstDay).endOf('month');
    let newEndDate : any = new Date(endDate)

    if(!isValid) {
      newStartDate = moment(newEndDate, 'DD/MM/YYYY').format();
      newStartDate = new Date(newStartDate)
      newStartDate.setHours(0,0,0,0);
    }

    let endOfMonthDate: any = moment(newEndDate, 'DD/MM/YYYY').format();
    endOfMonthDate = new Date(endOfMonthDate)
    endOfMonthDate.setHours(0,0,0,0);

    let endOfSupportDate = null
    let hasAndComparistion = false
    if(this.hasEndSupportDate) {
      let eof = new Date(this.hasEndSupportDate)
      endOfSupportDate = moment(eof, 'YYYY/DD/MM').format();
      endOfSupportDate = new Date(endOfSupportDate)
      endOfSupportDate.setHours(0,0,0,0);
      hasAndComparistion = true
    }

    let last: any = this.getLstDayOfMonFnc(new Date(this.startDate))

    if(startDay == moment(last).format('DD')) {
      newStartDate = endOfMonthDate
    }
    return( (moment(fechaFormat).isSame(this.startDate) && (hasAndComparistion ? moment(this.startDate).isSameOrBefore(endOfSupportDate)
    : true)) || (hasAndComparistion ? (moment(fechaFormat).isSame(newStartDate) && moment(newStartDate).isSameOrBefore(endOfSupportDate) &&  fechaFormat <= endOfSupportDate) : moment(fechaFormat).isSame(newStartDate)))
  }


  startDate: string;
  @Input() readonly = null
  constructor(private dateAdapter: DateAdapter<Date>,private route:ActivatedRoute,
    private translate:TranslateService,
    private commonService: CommonService
    ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy

    let current = new Date()
    this.maxDate = current
    if(!this.hideFutureDates) {
      this.maxDate.setFullYear(current.getFullYear() + 5)
    }

      let lang =  localStorage.getItem('locale')
      console.log(lang)
      this.dateAdapter.setLocale(lang);

  }
  date = new Date()

  getLstDayOfMonFnc(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  ngOnInit(): void {

  }

  ngOnChanges() {

    if (this.selectedDate) {
      this.OnDateChange(this.selectedDate);
    }
    else if (this.defaultDate !== undefined) {
      this.OnDateChange(this.defaultDate)
    }
    if(!this.hideFutureDates && !this.hasDateFilter) {
    if(this.minDate) {
       this.maxDate.setFullYear(this.minDate?.getFullYear() + 5);
    } else {
    this.maxDate.setFullYear(new Date().getFullYear() + 5);
    }
   } else {
    this.maxDate.setFullYear(new Date().getFullYear())
   }

   if(this.maxStartDate && !this.hasDateFilter) {
    this.maxDate = this.maxStartDate
   }
   if(this.maxStartDate && this.hpDropdownMaxDate) {
    this.maxDate = this.maxStartDate
   }
  }

  toggle(ref) {
    this.isDatePickerOpen.emit(ref.opened);
  }

  OnDateChange(event): any {
    this.date = new Date(event);
    this.displayDate = this.date
    this.getData(event);
  }

  getData(e) {
    this.passDates.emit(e);
    MATERIAL_DATEPICKER_FORMATS.parse.dateInput = this.commonService.getTheDateFormatForPicker()
    MATERIAL_DATEPICKER_FORMATS.display.dateInput = this.commonService.getTheDateFormatForPicker()
  }

  get pickerFormat() {
   return this.commonService.getTheDateFormatForPicker()
  }

  formatDateOnRegion(date) {
    return this.commonService.formatDate(date)
  }

}
@Component({
  selector: 'example-header',
  styles: [
    `
              .example-header {
                display: flex;
                align-items: center;
                padding: 0.5em;
              }
              .example-header button{
                border:none;
                background:transparent;
                cursor:pointer;
                margin-top:10px
              }
              .example-header-label {
                flex: 1;
                height: 1em;
                font-weight: 500;
                text-align: center;
              }
              .example-double-arrow .mat-icon {
                margin: -22%;
              }
            `,
  ],
  template: `
    <div class="example-header">
      <button id="custom-date-picker-prev-btn" mat-icon-button (click)="previousClicked()">
        <img style="transform: rotate(180deg);padding-left: 16px;" src="./assets/icons/arrow-right-black.svg" alt="arrow-right-icon">
      </button>
      <span class="example-header-label">{{periodLabel}}</span>
      <button id="custom-date-picker-next-btn" mat-icon-button (click)="nextClicked()">
      <img style="padding-right: 8px;" src="./assets/icons/arrow-right-black.svg" alt="arrow-right-icon">
      </button>

    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExampleHeader<D> implements OnDestroy {
  @Input() max: D | null

  private _destroyed = new Subject<void>();
  maxDate: any;


  constructor(
    private _calendar: MatCalendar<D>,
    private _dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
    cdr: ChangeDetectorRef
  ) {
    _calendar.stateChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => cdr.markForCheck());
    let current = new Date()

    this.maxDate = `${current.getDate()}/${current.getMonth()}/${current.getFullYear() + 1}`
    console.log(this.maxDate)
    console.log(current.getFullYear())
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }



  get periodLabel() {
    return this._dateAdapter
      .format(
        this._calendar.activeDate,
        this._dateFormats.display.monthYearLabel
      )
      .toLocaleUpperCase();
  }

  previousClicked() {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
      this._calendar.activeDate,
      -1
    );
  }

  nextClicked() {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
      this._calendar.activeDate,
      1
    );

  }
}
